export enum EnumLayerTypes {
    Point = 1,
    Lines = 2,
    Polygon = 3,
    Geofence = 4,
    ClusterPoints = 5,
    PrecalculatedPolygon = 6,
    Cloropet = 7
}